import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import AccountCreation from "@/components/signup/account-creation";
import { CobrandedProductLogo } from "@/components/signup/bxp-ui-signup/src/components/site-name-form/components/variants/new-user-confluence-workspace-name";
import { SignupBackgroundLayout } from "@/components/signup/layouts";
import { wacToken } from "@/libraries/design/foundations";
import { FeatureExposed } from "@/utils/feature-exposed";

import { InputSubmitButton } from "../../../components";
import { UnderlineWord } from "../../components";

export const LoggedOutConfluenceFree = () => (
    <div data-testid="logged-out-confluence-free">
        <FeatureExposed
            experimentKey="cfind-2409-v2-cobranding-signup"
            group="test"
        >
            <FeatureExposed
                experimentKey="jfind-1192-signup-button-update-cfind"
                group="test"
            >
                <SignupBackgroundLayout ProductLogo={<CobrandedProductLogo />}>
                    <h1 css={h1Css}>
                        <FormattedMessage
                            id="BxpUiSignup.SignupForm.cfind2049.header"
                            defaultMessage="Get <underline-word>started</underline-word> with Confluence"
                            values={{ "underline-word": UnderlineWord }}
                        />
                    </h1>
                    <p css={subHeaderCss}>
                        <FormattedMessage
                            id="signupForm.accountCreation.subHeaderText"
                            defaultMessage="It’s free for up to 10 users - no credit card needed."
                        />
                    </p>
                    <AccountCreation
                        Input={<InputSubmitButton />}
                        Submit={null}
                    />
                </SignupBackgroundLayout>
            </FeatureExposed>
        </FeatureExposed>
    </div>
);

const h1Css = css({
    color: wacToken("color.primary.black"),
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "32px",
    fontWeight: 700,
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    color: wacToken("color.primary.black"),
    margin: "0 0 24px",
    textAlign: "center"
});
